import script from "./WizardConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardConfirmModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
import TheModal from "@/components/TheModal.vue";
import WizardButton from "@/components/neue/wizard/WizardButton.vue";
script.components = Object.assign({}, { HighlightedText, TheModal, WizardButton }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { HighlightedText, TheModal, WizardButton }, script.__o.components);}